import { useReduxStore } from "../../hooks/useReduxStore";

const useUserSubscription = () => {
  const { getState } = useReduxStore();
  const {
    homeBanners,
    popularLoading,
    trendingLoading,
    categoriesItems,
    popularItems,
    trendingItems,
  } = getState("Home");

  return {
    homeBanners,
    popularLoading,
    trendingLoading,
    categoriesItems,
    popularItems,
    trendingItems,
  };
};

export default useUserSubscription;
